import React from "react";
import ReactPaginate from "react-paginate";
import moment from "moment";
import "./index.scss";
import { BOOKING_STATUS } from "../../../../constants/app";
import Dialog from "../../../shared/dialog";
import MyButton from "../../../shared/buttons/primary";
import DetailDialog from "../../../history/detail";

const BookingDetail = (props) => {
  const LIMIT = 20;
  const { userId, onCloseModalDetail, show } = props;
  const shopId = window.store.getState().auth.user.id;
  const [isLoading, setIsLoading] = React.useState(true);
  const [bookingDetails, setBookingDetails] = React.useState([]);
  const [bookingItemDetail, setBookingItemDetail] = React.useState({});
  const [isShowBookingItemDetail, setIsShowBookingItemDetail] =
    React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);

  React.useEffect(() => {
    handleFetchUserBookingDetail();
  }, [currentPage]);

  const handleOpenBookingItemDetail = (itemDetail) => {
    setIsShowBookingItemDetail(true);
    setBookingItemDetail(itemDetail);
  };

  const handleFetchUserBookingDetail = () => {
    window
      .axios({
        url: `booking/`,
        method: "get",
        params: {
          page: currentPage,
          limit: LIMIT,
          shop: shopId,
          user_id: userId,
        },
      })
      .then((result) => {
        setBookingDetails(result.data);
        setIsLoading(false);
      });
  };

  const handleChangePage = ({ selected }) => {
    setCurrentPage(+selected + 1);
  };

  const renderLoading = () => {
    return (
      <div className="loader-wrapper">
        <div className="loader">Loading...</div>
      </div>
    );
  };

  const renderEmptyData = () => {
    return (
      <tr>
        <td colSpan="6">予約履歴がありません</td>
      </tr>
    );
  };

  const renderPagination = () => {
    const isShowPagination = bookingDetails?.count > 20;
    if (!isShowPagination) return null;

    return (
      <ReactPaginate
        previousLabel={<span className="material-icons">chevron_left</span>}
        nextLabel={<span className="material-icons">chevron_right</span>}
        disabledClassName={"navigation-disabled"}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={Math.ceil(bookingDetails?.count / LIMIT)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handleChangePage}
        containerClassName={"my-pagination"}
        subContainerClassName={"pages pagination"}
        activeClassName={"active"}
      />
    );
  };

  const truncateValue = (value, length, omission) => {
    if (!value) return null;

    return window._.truncate(value, {
      length: length,
      omission,
    });
  };

  const renderBookingStatus = (status) => {
    const statusOption = BOOKING_STATUS.find(
      (__status) => __status.value === status
    );
    if (!statusOption) return null;
    return statusOption.label;
  };

  const renderDateTimeElm = (date) => {
    if (!date) return null;
    return moment(date).format("YYYY年MM月DD日 hh:mm a");
  };

  const renderTableRow = () => {
    const listBooking = bookingDetails?.results ?? [];
    if (!listBooking.length) return renderEmptyData();

    return listBooking.map((item) => (
      <tr key={item.id}>
        <td>
          {truncateValue(
            item.username || item.user.username || item.user.full_name,
            30,
            "..."
          )}
        </td>
        <td>
          {truncateValue(item.menu.map((i) => i.name).join(", "), 30, "...")}
        </td>
        <td>{renderBookingStatus(item.status)}</td>
        <td>
          {renderDateTimeElm(item.start_time)}{" "}
          {renderDateTimeElm(item.end_time)}
        </td>
        <td>{renderDateTimeElm(item.cancel_time)}</td>
        <td>
          <MyButton
            myVariant="detail"
            onClick={() => handleOpenBookingItemDetail(item)}
          >
            詳細
          </MyButton>
        </td>
      </tr>
    ));
  };

  const renderModalButton = () => {
    return (
      <div className="booking-form__btns">
        <MyButton myVariant="cancel" onClick={() => onCloseModalDetail()}>
          キャンセル
        </MyButton>
      </div>
    );
  };

  const renderPageContent = () => {
    if (isLoading) return renderLoading();
    return (
      <>
        <div className="user-booking-detail__table history__table">
          <table className="table">
            <thead className="">
              <tr>
                <th scope="col" className="col-username">
                  ユーザー名
                </th>
                <th scope="col" className="col-service">
                  メニュー
                </th>
                <th scope="col" className="col-status">
                  ステータス
                </th>
                <th scope="col" className="col-time">
                  予約時間
                </th>
                <th scope="col" className="col-cancel-time">
                  キャンセル時間
                </th>
                <th scope="col" className="col-activity">
                  操作
                </th>
              </tr>
            </thead>
            <tbody>{renderTableRow()}</tbody>
          </table>
        </div>
        {renderPagination()}
        {renderModalButton()}
      </>
    );
  };

  return (
    <>
      <Dialog
        id="booking-detail-dialog"
        className={"booking-dialog booking-detail-dialog w-80"}
        title={"予約履歴"}
        isShow={!!show}
        onCloseRequest={() => onCloseModalDetail()}
        closeOnOverlayClick={false}
      >
        {renderPageContent()}
      </Dialog>
      {isShowBookingItemDetail && (
        <DetailDialog
          isShow={isShowBookingItemDetail}
          onClose={() => {
            setIsShowBookingItemDetail(false);
            setBookingItemDetail({});
          }}
          data={bookingItemDetail}
        />
      )}
    </>
  );
};

export default React.memo(BookingDetail);
